//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("physicalInstallation", PhysicalInstallationFactory);

    PhysicalInstallationFactory.$inject = ["apiClientFactory"];
    function PhysicalInstallationFactory(apiClientFactory) {

        const routePrefix = "api/Installation/";

        return {
            DownloadExport: apiClientFactory.postFile(routePrefix + "Export/"),
            Get: apiClientFactory.get(routePrefix),
            GetRequests: apiClientFactory.get(routePrefix + "Requests/"),
            GetSecuredZonesForOrganisation: apiClientFactory.get(routePrefix + "ForOrganisation/"),
            Search: apiClientFactory.post(routePrefix + "Search/"),
            SearchMine: apiClientFactory.post(routePrefix + "SearchMine/"),
        };
    }
})();
